import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const SplatModeIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick, strokeWidth = 1.5 }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      {/* 3 Gaussian splat ellipses - simple and clear */}
      {/* Top ellipse */}
      <ellipse cx="12" cy="7" rx="5" ry="2.5" stroke={color} strokeWidth={strokeWidth} fill={color} fillOpacity="0.3" />
      {/* Middle ellipse (slightly offset) */}
      <ellipse cx="10" cy="12" rx="4.5" ry="2.2" stroke={color} strokeWidth={strokeWidth} fill={color} fillOpacity="0.3" />
      {/* Bottom ellipse */}
      <ellipse cx="13" cy="17" rx="5" ry="2.5" stroke={color} strokeWidth={strokeWidth} fill={color} fillOpacity="0.3" />
    </BaseIcon>
  ),
);

SplatModeIcon.displayName = 'SplatModeIcon';
